document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('custom-search-popup');
  const input = document.getElementById('cs-input');
  const reset = document.getElementById('cs-reset');
  const close = document.getElementById('cs-close');
  const results = document.getElementById('cs-results');

  if (!popup || !input || !reset || !close || !results) return;

  const cursor = document.createElement('div');
  cursor.className = 'cs-cursor';
  cursor.textContent = '×';
  document.body.appendChild(cursor);

  function openSearch(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    popup.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input.focus(), 120);
  }

  function closeSearch() {
    popup.classList.remove('is-open', 'has-text');
    input.value = '';
    results.innerHTML = '';
    document.body.style.overflow = '';
    cursor.style.display = 'none';
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest('.google-duftnoten-btn')) return;

    const trigger = event.target.closest(
      'a[href="/search"], a[href="/search/"], button[aria-label="Search"], button[aria-label="Suche"], button[aria-label="Suchen"], .header__search, .header-search-trigger'
    );

    if (trigger) {
      openSearch(event);
      return;
    }

    if (popup.classList.contains('is-open') && event.target === popup) {
      closeSearch();
    }
  }, true);

  popup.addEventListener('mousemove', (event) => {
    if (window.innerWidth < 750) return;

    if (event.target.closest('.cs-box')) {
      cursor.style.display = 'none';
      return;
    }

    cursor.style.display = 'flex';
    cursor.style.left = event.clientX + 'px';
    cursor.style.top = event.clientY + 'px';
  });

  popup.addEventListener('mouseleave', () => {
    cursor.style.display = 'none';
  });

  close.addEventListener('click', closeSearch);

  reset.addEventListener('click', () => {
    input.value = '';
    results.innerHTML = '';
    popup.classList.remove('has-text');
    input.focus();
  });

  let timer;

  input.addEventListener('input', () => {
    const query = input.value.trim();

    popup.classList.toggle('has-text', query.length > 0);
    clearTimeout(timer);

    if (!query) {
      results.innerHTML = '';
      return;
    }

    timer = setTimeout(async () => {
      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=20`
        );

        const data = await response.json();

        const products = data.resources.results.products || [];
        const collections = data.resources.results.collections || [];

        let html = '';

        if (collections.length > 0) {
          html += `<div class="cs-section-title">Kategorien</div>`;

          html += collections.map(collection => `
            <a class="cs-category" href="${collection.url}">
              <div class="cs-category-title">${collection.title}</div>
            </a>
          `).join('');
        }

        if (products.length > 0) {
          html += `<div class="cs-section-title">Produkte</div>`;

          html += products.map(product => `
            <a class="cs-product" href="${product.url}">
              <img src="${product.image || ''}" alt="${product.title}">
              <div>
                <div class="cs-title">${product.title}</div>
                <div class="cs-price">ab ${product.price || ''}</div>
              </div>
            </a>
          `).join('');
        }

        if (!html) {
          html = `<div class="cs-empty">Keine Ergebnisse gefunden.</div>`;
        }

        results.innerHTML = html;
      } catch (error) {
        results.innerHTML = '';
      }
    }, 250);
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeSearch();
  });
});